module.exports = __webpack_public_path__ + "static/media/fondo_cotizador.72989129.png";